/**
 * ThememanagementUtility
 * Darkmodededicated（Lightmode）
 */

export type Theme = 'dark';

/**
 * CurrentThemeGet（Dark）
 */
export function getTheme(): Theme {
  return 'dark';
}

/**
 * ThemeSet（Darkmodeforskip）
 */
export function setTheme(_theme: Theme): void {
 // Darkmodededicatedfor forskip
}

/**
 * Themeapply（DarkmodeSet）
 */
export function applyTheme(_theme: Theme): void {
  if (typeof window === 'undefined') return;

  const root = document.documentElement;
  root.setAttribute('data-theme', 'dark');
}

/**
 * ThemeChange（for）
 */
export function watchSystemTheme(_callback: (isDark: boolean) => void): () => void {
 // Darkmodebecauseskip
  return () => {};
}

/**
 * InitializeonThemeapply
 */
export function initTheme(): void {
  applyTheme('dark');
}
